import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LayoutContainer from "../../components/LayoutsContainer";
import {
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import UseMobile from "../../hooks/useIsMobile";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // marginTop: theme.spacing(7),

    borderRadius: 20,
    padding: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
  },
  itemContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      alignItems: "flex-end",
    },
  },
  countContainer: {
    height: "13vh",
    width: "13vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    borderRadius: 300,
    [theme.breakpoints.down("md")]: {
      height: "auto",
      width: "auto",
      padding: theme.spacing(1),
      paddingRight: 0,

      backgroundColor: "transparent",
      flexDirection: "row",
    },
  },
  count: {
    ...fontConfig.bold,
    fontSize: "2rem",
    color: "white",
    [theme.breakpoints.down("md")]: {
      fontSize: "2rem",
      color: "white",
      textAlign: "right",
    },
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2rem",
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.3rem",
      color: theme.palette.secondary.main,
      textAlign: "right",
      // WebkitTextStroke: `0.5px black`,
      // textStroke: `0.5px black`,
    },
  },
}));

const CounterContainer = ({ data }) => {
  const classes = useStyles();
  const renderCounterItem = (item, index) => {
    return (
      <div key={index} className={classes.itemContainer}>
        <div className={classes.countContainer}>
          <Typography className={classes.count}>{item.count}</Typography>
        </div>

        <Typography className={classes.title}>{item.title}</Typography>
      </div>
    );
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const Background = "/images/background/counterbg.png";
  const mobileBackground = "/images/background/mobilecounterbg.png";

  const desktopBg = {
    backgroundImage: `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)),  url(${Background})`,
    height: "100%",
    width: "100%",
    backgroundSize: "100% 100%",
  };

  const mobileBg = {
    backgroundImage: `linear-gradient(to right,rgba(0,0,0,0), rgba(0,0,0,.8)), url(${mobileBackground}) `,

    height: "100%",
    width: "100%",

    backgroundPosition: "center",
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
  };
  return (
    <div style={isMobile ? mobileBg : desktopBg}>
      <Container maxWidth="lg">
        <div className={classes.root}>
          {data?.data?.map((item, index) => renderCounterItem(item, index))}
        </div>
      </Container>
    </div>
  );
};
export default CounterContainer;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Box,
//   Container,
//   Divider,
//   Grid,
//   Hidden,
//   Paper,
//   Typography,
// } from "@material-ui/core";
// import fontConfig from "../../constants/fonts";
// import TitleContainer from "./TitleContainer";
// import LeftCounters from "./LeftCounters";
// import RightContainer from "./RightContainer";
// import LayoutContainer from "../../components/LayoutsContainer";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     height: 550,
//     display: "flex",
//     width: "100%",
//     justifyContent: "center",
//     alignItems: "center",
//     [theme.breakpoints.down("md")]: {
//       // padding: `2vh 0vw`,
//       height: "auto",
//     },
//     // paddingBottom: "5vh",
//   },

//   titleContainer: {},
//   title: {
//     ...fontConfig.bold,
//     fontSize: "3rem",
//     color: theme.palette.primary.main,
//     fontFamily: "Montserrat",
//     textTransform: "uppercase",
//     letterSpacing: "0.1rem",
//     // backgroundColor: theme.palette.primary.main,
//     borderRadius: 100,
//     // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
//     // width: "20%",
//     // width: "15%",
//     textAlign: "center",
//     padding: "20px 20px 5px 20px",
//     // padding: "10 30px",
//     // wordWrap: "no-wrap",
//   },

//   Paper: {
//     backgroundColor: "transparent",
//     width: "100%",
//     // height: "100%",
//   },
//   Divider: {
//     backgroundColor: theme.palette.secondary.main,
//     width: "10vw",
//     height: "4px",
//     borderRadius: 100,
//   },
//   gridContainer: {
//     backgroundColor: "white",
//     height: "65vh",
//     borderRadius: 20,
//     [theme.breakpoints.down("md")]: {
//       height: "auto",
//     },
//   },
// }));

// const CounterContainer = ({ data }) => {
//   const classes = useStyles();
//   console.log("counter data", data);
//   return (
//     <>
//       <LayoutContainer>
//         <div className={classes.root}>
//           <Paper elevation={0} className={classes.Paper}>
//             <Grid container className={classes.gridContainer}>
//               <Grid item lg={8}>
//                 <LeftCounters data={data} />
//               </Grid>
//               <Hidden mdDown>
//                 <Grid item lg={4}>
//                   <RightContainer data={data.data[4]} />
//                 </Grid>
//               </Hidden>
//             </Grid>

//             {/* {data?.title && (
//               <Grid container justify="center">
//                 <Grid item className={classes.titleContainer}>
//                   <Typography variant="h6" className={classes.title}>
//                     {data.title}
//                   </Typography>
//                 </Grid>
//                 <Grid
//                   item
//                   lg={12}
//                   container
//                   alignItems="center"
//                   justify="center"
//                 >
//                   <Divider className={classes.Divider} />
//                 </Grid>
//               </Grid>
//             )}
//             <Grid
//               container
//               spacing={2}
//               className={classes.personalityContainer}
//             >
//               {data.data.map((man, index) => {
//                 return (
//                   <Grid item key={index}>
//                     <CounterContainerItem data={man} />
//                   </Grid>
//                 );
//               })}
//             </Grid> */}
//           </Paper>

//           {/* </LayoutContainer> */}
//         </div>
//       </LayoutContainer>
//     </>
//   );
// };
// export default CounterContainer;

// // import React from "react";
// // import { makeStyles } from "@material-ui/core/styles";

// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     [theme.breakpoints.down("md")]: {
// //       backgroundColor: "white",
// //     },
// //   },
// // }));

// // const PortFolio = () => {
// //   const classes = useStyles();

// //   return (
// //     <div className={classes.root}>
// //       <section
// //         id="portfolioCarousel"
// //         class="portfolio-carousel portfolio-classic pt-90 pb-70"
// //       >
// //         <div class="container">
// //           <div class="row mb-50">
// //             <div class="col-sm-12 col-md-12 col-lg-7">
// //               <div class="heading">
// //                 <span class="heading__subtitle">
// //                   We Work With Global Industries!
// //                 </span>
// //                 <h3 class="heading__title mb-0">Featured portfolio</h3>
// //               </div>
// //             </div>
// //             {/* <div class="col-sm-12 col-md-12 col-lg-5">
// //               <div class="cta__banner">
// //                 <div class="bg-img">
// //                   <img
// //                     src="assets/images/backgrounds/pattern/1.jpg"
// //                     alt="background"
// //                   />
// //                 </div>
// //                 <h5 class="cta__title">
// //                   Dedicated Customer <br /> Teams &amp; An Agile Services
// //                 </h5>
// //                 <p class="cta__desc">
// //                   Building relationships and portfolio that last. Serving an
// //                   impressive list of long-term clients with experience and
// //                   expertise in industries.
// //                 </p>
// //                 <a class="btn btn__white btn__link" href="#">
// //                   {" "}
// //                   View Our Works{" "}
// //                 </a>
// //               </div>
// //             </div> */}
// //           </div>
// //           <div class="row">
// //             <div class="col-sm-12 col-md-12 col-lg-12">
// //               <div
// //                 class="carousel owl-carousel carousel-arrows"
// //                 data-slide="3"
// //                 data-slide-md="2"
// //                 data-slide-sm="1"
// //                 data-autoplay="true"
// //                 data-nav="true"
// //                 data-dots="false"
// //                 data-space="30"
// //                 data-loop="true"
// //                 data-speed="800"
// //               >
// //                 <div class="portfolio-item">
// //                   <div class="portfolio__img">
// //                     <img
// //                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
// //                       alt="portfolio img"
// //                     />{" "}
// //                     {/* <a class="view__icon" href="#">
// //                       View
// //                     </a> */}
// //                   </div>
// //                   <div class="portfolio__content">
// //                     <h4 class="portfolio__title">
// //                       <a href="#">શ્રી અમરેન્દ્ર કુમાર રાકેશ​ આઇ. એ. એસ.</a>
// //                     </h4>
// //                     <div class="portfolio__cat">
// //                       <a href="#">
// //                         અધિક મુખ્ય સચિવશ્રી (પંચાયત, ગ્રામ ગૃહનિર્માણ અને ગ્રામ
// //                         વિકાસ વિભાગ)
// //                       </a>
// //                       {/* <a href="#">oil &amp; Gas</a> */}
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div class="portfolio-item">
// //                   <div class="portfolio__img">
// //                     <img
// //                       src="http://jepurpanchayat.com/assets/images/products/p4.jpg"
// //                       alt="portfolio img"
// //                     />{" "}
// //                     {/* <a class="view__icon" href="#">
// //                       View
// //                     </a> */}
// //                   </div>
// //                   <div class="portfolio__content">
// //                     <h4 class="portfolio__title">
// //                       <a href="#">પ્રહલાદભાઈ એચ. પટેલ</a>
// //                     </h4>
// //                     <div class="portfolio__cat">
// //                       <a href="#">ઉપ સરપંચશ્રી </a>
// //                       <a href="#">+૯૧-૯૦૯ ૯૪૨ ૨૮૬૦</a>
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div class="portfolio-item">
// //                   <div class="portfolio__img">
// //                     <img
// //                       src="http://jepurpanchayat.com/assets/images/products/p1.jpg"
// //                       alt="portfolio img"
// //                     />{" "}
// //                     {/* <a class="view__icon" href="#">
// //                       View
// //                     </a> */}
// //                   </div>
// //                   <div class="portfolio__content">
// //                     <h4 class="portfolio__title">
// //                       <a href="#">શ્રી રામાજી રાણાજી વણઝારા</a>
// //                     </h4>
// //                     <div class="portfolio__cat">
// //                       <a href="#">ગ્રામસેવક</a>
// //                       <a href="#">+૯૧-૭૮૭૪૨૪૪૯૩૫</a>
// //                     </div>
// //                   </div>
// //                 </div>
// //                 {/* <div class="portfolio-item">
// //                   <div class="portfolio__img">
// //                     <img
// //                       src="http://jepurpanchayat.com/assets/images/products/p2.jpg"
// //                       alt="portfolio img"
// //                     />{" "}
// //                     <a class="view__icon" href="#">
// //                       View
// //                     </a>
// //                   </div>
// //                   <div class="portfolio__content">
// //                     <h4 class="portfolio__title">
// //                       <a href="#">Regulatory Compliance Seminar</a>
// //                     </h4>
// //                     <div class="portfolio__cat">
// //                       <a href="#">Construction</a>
// //                       <a href="#">Engineering</a>
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div class="portfolio-item">
// //                   <div class="portfolio__img">
// //                     <img
// //                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
// //                       alt="portfolio img"
// //                     />{" "}
// //                     <a class="view__icon" href="#">
// //                       View
// //                     </a>
// //                   </div>
// //                   <div class="portfolio__content">
// //                     <h4 class="portfolio__title">
// //                       <a href="#">Documents &amp; Electronic Data</a>
// //                     </h4>
// //                     <div class="portfolio__cat">
// //                       <a href="#">Engineering</a>
// //                       <a href="#">oil &amp; Gas</a>
// //                     </div>
// //                   </div>
// //                 </div> */}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };
// // export default PortFolio;
